import Resource from '@/api/resources/Resource'

class PersonnelConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/personnel`, filterModel, { params })
        return response.data
    }
    async getPersonnelByName(params) {
        const response = await this.axios.get(`/configuration/personnel/search`, { params })
        return response.data
    }
    async getPersonnelById(personnelId) {
        const response = await this.axios.get(`/configuration/personnel/${personnelId}`)
        return response.data
    }
    async patchPersonnelBatch(personnel) {
        const response = await this.axios.patch(`/configuration/personnel/batch`, personnel)
        return response.data
    }
    async createPersonnel(personnel) {
        const response = await this.axios.post(`/configuration/personnel`, personnel)
        return response.data
    }
    async deletePersonnelBatch(personnel) {
        const data = {
            entityIdentifiers: personnel
        }
        const response = await this.axios.delete(`/configuration/personnel/batch`, { data: data })
        return response.data
    }
}

export default new PersonnelConfigurationServices()
